module.exports = __webpack_public_path__ + "img/slim_cleanstation16.b3699cd7.jpg";